import { render, staticRenderFns } from "./DbGisSettings.vue?vue&type=template&id=29a1e2da&scoped=true&"
import script from "./DbGisSettings.vue?vue&type=script&lang=js&"
export * from "./DbGisSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1e2da",
  null
  
)

export default component.exports